import React from "react";
import Breadcrumb from "../../Components/Breadcrumb/Breadcrumb";
import AllAcountsSection from "../../Components/AllAccountsSection/AllAcountsSection";
import {
  AiFillCaretRight,
  AiOutlineArrowRight,
  AiOutlineArrowUp,
} from "react-icons/ai";
import { useState } from "react";
import SavePlusAccountComponent from "../../Components/SavePlusAccount/SavePlusAccountComponent";
import ContainsArea from "../../Components/ContainsArea/ContainsArea";
import { useEffect } from "react";

const IndoVehicleLoan = () => {
  const img1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB-21.png";
const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-vehicle-loan-banner.png";
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  const accountContent =
    "With our Indo Vehicle Loans you dream car can be a reality. Bring your dreams to life with competitive interest rates and low processing fees, making it easy for you to access the financing you need to achieve your dream. ";
  const [show, setShow] = useState(false);


  const [openIndex, setOpenIndex] = useState(null);

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index );
  }

  const accordionData = [
    {
      title: "Features",
      content: [
        "Low interest rate", 
        "Applications processed within 72hrs (Terms and conditions apply)",
        "0.5% less on rate of interest for women",
        "Tailored repayment periods up to 72 months",
        "Reimbursement on cost of brand-new vehicles",
      ],
    },
    {
      title: "Eligibility",
      content: [
        "Salaried employees on either permanent or contractual terms with reputable corporate institution such as government departments, parastatals and the private sector",
        "Self employed business people with legal identifiable and regular source of income",
        "Parents, spouses and children may be accepted as co borrowers to improve the entitlement/repayment capacity of the borrower. However, the number of co-borrowers should not exceed two.",
        "Indo Vehicle Finance is available to existing customers of the bank who have maintained banking relationships for at least one year.",
      ],
    },
    {
      title: "Currency",
      content: ["ZMW", "USD"],
    },
    {
      title: "Purpose of the Loan",
      content: [
        "Finance the purchase of brand new two-wheeler and four-wheeler vehicles, including electric vehicles and super bikes from an authorized automobile dealer for personal use.",
        "To finance the purchase of second had four-wheeler vehicles (not exceeding 5 years old) form reputable dealers for personal use.",
        "To finance the purchase of water vehicles such as motorboats, sports boats and other watercraft for personal use.",
        "Takeover of vehicles from other financial institutions",
        "Reimbursement of cost of four-wheeler vehicles purchased from own source (Terms and conditions apply)",
      ],
    },
    {
      title: "Repayment Terms",
      content: [
        "For brand new vehicles: maximum 72 months",
        "For pre-owned vehicles: maximum 60 months",
      ],
    },
    {
      title: "Interest Rates",
      content: [
        "BOZ Policy Rate plus margin",
        "Competitive rates in Zambian Kwacha or USD",
        "Discounts available for higher upfront contributions or electric vehicles",
        "Lower rates applicable for female primary borrowers"
      ],
    },
    {
      title: "Turn around Time",
      content: ["Within 72 hours of submission of final document"],
    },
  
    {
      title: "How to Apply",
      content: ['To apply now, email <a href="mailto:credit@izb.co.zm">credit@izb.co.zm</a> or call <a href="tel:8002">8002</a>'],
    },
  ];

  return (
    <>
      <Breadcrumb Heading="Indo Vehicle Loan" img={BackgroundBrundcrumb} show={true} btnTxt="Apply Now" />
      <SavePlusAccountComponent
        heading="Indo Vehicle Loan"
        subHeading="Know About"
        btnTxt="Apply Now"
        content={accountContent}
        img={img1}
        logo={true}
      />
      <ContainsArea />
      <section className="faq-section">
        <div className="container">
          <div className="row">
            <div className="col-xl-12 justify-content-center">
              <div className="faq-style1__content">
                <ul className="accordion-box mt-5">


                  {accordionData.map((item, index) => (
                     <li className="accordion block active-block" key={index}>
                      <div
                        className="acc-btn active"
                        style={{
                          backgroundColor: "#9E1B1E",
                          backgroundSize: "20px",
                        }}
                        onClick={() => handleToggle(index)}
                      >
                        <div className="icon-outer text-white">
                          {openIndex === index ? <AiOutlineArrowRight /> : <AiOutlineArrowUp /> }
                        </div>
                        <h3 className="text-white" onClick={() => setShow(!show)}>
                        {item.title}
                        </h3>
                      </div>
                      {openIndex === index && (
                        <div className="acc-content current">
                           {item.content.map((point, idx) => (
                            <p key={idx} className="">
                              <AiFillCaretRight className="me-1 accordion-icon" />
                              <span className="mt-1" dangerouslySetInnerHTML={{ __html: point }} />
                            </p>
                          ))}
                        </div>
                      )}
                    </li>
                  ))}
                 


                </ul>
              </div>
            </div>
          
          </div>
        </div>
      </section>
      <AllAcountsSection />
    </>
  );
};

export default IndoVehicleLoan;
